import { isRejectedWithValue } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import type { Middleware } from '@reduxjs/toolkit';

export const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
	if (isRejectedWithValue(action)) {
		// get the error message from the action payload
		const errorMessage =
			action.payload && typeof action.payload === 'object' && 'message' in action.payload
				? (action.payload as { message: string }).message
				: 'An error occurred while performing the action. Please try again.';
		toast.error(errorMessage);
		// Optionally, you can also log the error to an external service here
		// For example: logErrorToService(action.payload);
		// Or simply log it to the console for development purposes:
		console.error('RTK Query Error:', action.payload);
	}

	return next(action);
};
